import { Label } from '@cian/ui-kit';
import * as React from 'react';
import clsx from 'clsx';

import * as styles from './PriceDiscount.css';

interface IPriceDiscountProps {
  oldPrice: string;
  percent: string;
  className?: string;
}

export const PriceDiscount: React.FC<IPriceDiscountProps> = ({ oldPrice, percent, className }) => {
  return (
    <span className={clsx(styles['price-discount'], className)} data-testid="price-discount">
      <Label background="accent-positive-primary" color="text-inverted-default">
        {percent}
      </Label>
      <span className={styles['old-price']}>{oldPrice}</span>
    </span>
  );
};
